import { StylishLoading } from '@organisms/Feedbacks';
import React from 'react';
import styled from 'styled-components';

const Loading = () => {
    return (
        <LoadingPageWithStyled>
            <StylishLoading loading={true}/>
        </LoadingPageWithStyled>
    );
};

const LoadingPageWithStyled = styled.div`
    color: #666;
    display: flex;
    font-size: 16px;
    justify-content: center;
    align-items: center;
    position: relative;
    & > * {
        width: 100vw;
        height: 100vh;
    }
`

export default Loading;
